export default __webpack_public_path__ + "static/media/russia.1da0e3f3.svg";